module.exports = __webpack_public_path__ + "img/wreck_sailorstoken.7fc72cf.png";